import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  productName: yup.string().required("Product name is required"),
  productSku: yup.string().nullable(true),
  categories: yup
    .array()
    .of(yup.string().required())
    .min(1, "At least one category is required")
    .required("Category is required"),
  stores: yup
    .array()
    .min(1, "Minimum of one store is required")
    .required("Minimum of one store is required"),
  storeProperties: yup.array().of(
    yup.object().shape({
      cost_price: yup.string().required("Cost price is required"),
      minimum_stock_quantity: yup.mixed().optional(),
      stock_quantity: yup.mixed().optional(),
      pricings: yup.array().of(
        yup.object().shape({
          price: yup.string().required("Selling price is required"),
          pricing_type_id: yup
            .string()
            .nullable()
            .required("Pricing type is required"),
        }),
      ),
    }),
  ),
});

export const Validation = ({ rootFormDetails, storeProperties }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      productName: rootFormDetails.name,
      productSku: rootFormDetails.sku,
      categories: rootFormDetails.categories,
      stores: rootFormDetails.stores,
      storeProperties,
    },
  });
};
